module.exports = __webpack_public_path__ + "static/tealbook-logo-6caa84462594f1d3f89e968fc0fbee24.png";